import React from "react";
import Ball from "./Ball";
const FourthSection = () => {
  return (
    <div className="fourthSection">
      <img className="threeD-image2" src="images/3d-img2.png" alt='3d-pic' />
      <div className="top-container">
        <span className="grey">What I have learned so far</span>
        <h1> Skills </h1>
      </div>

      <div className="ball-text-container">
        <div className="text-box">
          <p className="text">
            I possess a strong skill set in MERN (MongoDB, Express.js, React.js,
            Node.js) stack development, allowing me to build robust and scalable
            applications. As a self-taught developer, I have diligently honed my
            skills in technologies like Framer-motion, Three.js, and more. My
            passion lies in solving complex problems, and I approach them with
            enthusiasm and creative thinking.
          </p>
        </div>

        <div className="hl-box">
          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/html.png" alt='html-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/html.png" />
              <div className="heading">
                <h3>HTML</h3>
              </div>
            </div>
          </div>

          <div className="vertical-big">
            {/* <div className="pic"> */}
            <img src="/tech/bootstrap-logo.png" alt='bootstrap-pic' />
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/bootstrap-logo.png" />
              <div className="heading">
                <h3>Bootstrap</h3>
              </div>
            </div>
          </div>

          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/css.png" alt='css-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/css.png" />
              <div className="heading">
                <h3>CSS</h3>
              </div>
            </div>
          </div>

          <div className="vertical-big">
            {/* <div className="pic"> */}
            <img src="/tech/framer.png"alt='framer-pic' />
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/framer.png" />
              <div className="heading">
                <h3>Framer</h3>
              </div>
            </div>
          </div>

          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/javascript.png" alt='JS-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/javascript.png" />
              <div className="heading">
                <h3>JavaScript</h3>
              </div>
            </div>
          </div>

          <div className="vertical-big">
            {/* <div className="pic"> */}
            <img src="/tech/express.png" alt='express-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/express.png" />
              <div className="heading">
                <h3>ExpressJS</h3>
              </div>
            </div>
          </div>

          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/mongodb.png" alt='mongoDB-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/mongodb.png" />
              <div className="heading">
                <h3>MongoDB</h3>
              </div>
            </div>
          </div>

          <div className="vertical-big">
            {/* <div className="pic"> */}
            <img src="/tech/reactjs.png" alt='reactJS-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/reactjs.png" />
              <div className="heading">
                <h3>ReactJS</h3>
              </div>
            </div>
          </div>

          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/git.png" alt='git-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/git.png" />
              <div className="heading">
                <h3>Git</h3>
              </div>
            </div>
          </div>

          <div className="vertical-big">
            {/* <div className="pic"> */}
            <img src="/tech/three-js.png" alt='threeJS-pic'/>
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/three-js.png" />
              <div className="heading">
                <h3>ThreeJS</h3>
              </div>
            </div>
          </div>

          <div className="vertical-small">
            {/* <div className="pic"> */}
            <img src="/tech/nodejs.png"  alt='nodeJS-pic' />
            {/* </div> */}
            <div className="container">
              <Ball imageURL="/tech/nodejs.png"/>
              <div className="heading">
                <h3>NodeJS</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthSection;
